import { create } from 'zustand';
import * as storageConstants from '../Constants/storageConstant';
import { getLocalData } from '../Services/common';

const useStore = create((set, get) => ({
  masterData: null,
  systemData: null,
  status: [],
  userOptions: [],
  vehicleOptions: [],
  isHydrated: false,

  // Hydrate store from localStorage on init
  hydrate: () => {
    const masterData = getLocalData(storageConstants.MASTER_DATA);
    const systemData = getLocalData(storageConstants.SYSTEM_DATA);
    const status = getLocalData(storageConstants.STATUS);

    set({
      masterData,
      systemData,
      status: Array.isArray(status) ? status : [],
      isHydrated: true,
    });
  },

  setMasterData: (data) => set({ masterData: data }),
  setSystemData: (data) => set({ systemData: data }),
  setStatus: (data) => set({ status: Array.isArray(data) ? data : [] }),
  setUserOptions: (data) => set({ userOptions: Array.isArray(data) ? data : [] }),
  setVehicleOptions: (data) => set({ vehicleOptions: Array.isArray(data) ? data : [] }),

  // Actions to help with data retrieval (optional helpers)
  getCountryOptions: () => {
    const { systemData } = get();
    if (systemData?.countries) {
      return systemData.countries.map(c => ({
        label: c.value,
        value: c.key,
      }));
    }
    return [];
  },

  clearStore: () => set({ masterData: null, systemData: null, status: [], isHydrated: false }),
}));

export default useStore;
